export default __webpack_public_path__ + "static/sapphire-crystal-2b9f0203200cbaa3a235083363e1edf4.png";